<ng-container *transloco="let t">
<div (click)="onEditClicked()"
  class="hidden-when-mobile notice d-flex rounded border-primary border border-dashed min-w-lg-600px align-items-center flex-shrink-0 b-4 p-6 mb-4 btn btn-outline"
  [ngClass]="{
    'btn-outline-dashed': asset.isValid && !isReadOnly,
    'btn-outline-primary': asset.isValid && !isReadOnly,
    'btn-active-light-primary': asset.isValid && !isReadOnly,
    'border-danger': !asset.isValid && !isReadOnly,
    'btn-active-light-danger': !asset.isValid && !isReadOnly,
    'readonly-item': isReadOnly
  }">
  @if (!insideGroup) {
    <span class="svg-icon svg-icon-2x svg-icon-primary me-4 align-items-center duotone-home-svg-mobile"
      style="padding-bottom: 2px;"
      [ngClass]="{'svg-icon-primary': asset.isValid && !isReadOnly, 'svg-icon-danger': !asset.isValid && !isReadOnly}">
      <ng-template svgIconHost></ng-template>
    </span>
  } @else {
    <!-- Reserved icon slot when rendered inside a group card, so child rows align horizontally with standalone rows that show an icon. -->
    <span class="svg-icon svg-icon-2x me-4" aria-hidden="true"></span>
  }
  <div class="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap align-items-center">
    <span class="fs-6 text-gray-600 d-block fw-bold" style="min-width: 200px; text-align: left;">{{assetTypeLabel}}</span>
    <div class="d-flex justify-content-end align-items-center">
      <label class="text-gray-600 px-4" style="text-align: left;">{{ t('wizard.assets.borrowerLabel') }} {{ asset.assetOwners }}</label>
      <label class="text-gray-600 px-4" style="min-width: 175px; text-align: left;">{{ t('wizard.assets.valueLabel') }} {{ asset.value | currency }}</label>
      <div class="align-self-center text-nowrap">
        @if (!isReadOnly) {
          <div class="d-flex">
            <a href="javascript:void(0);" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
              (click)="onDeleteClicked($event)">
              <span class="svg-icon svg-icon-3">
                <duotone-trash-svg-icon></duotone-trash-svg-icon>
              </span>
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div (click)="onEditClicked()"
  class="hidden-when-not-mobile align-items-center rounded border-primary border border-dashed min-w-lg-600px mb-4"
  [ngClass]="{
    'border-danger': !asset.isValid && !isReadOnly,
    'btn-active-light-danger': !asset.isValid && !isReadOnly,
    'readonly-item': isReadOnly
  }"
  style="padding: 5px !important;">
  @if (!insideGroup) {
    <span class="svg-icon svg-icon-2x svg-icon-primary me-4 align-items-center duotone-home-svg-mobile"
      style="padding-bottom: 2px;"
      [ngClass]="{'svg-icon-primary': asset.isValid && !isReadOnly, 'svg-icon-danger': !asset.isValid && !isReadOnly}">
      <ng-template svgIconHost></ng-template>
    </span>
  } @else {
    <!-- Reserved icon slot when rendered inside a group card, so child rows align horizontally with standalone rows that show an icon. -->
    <span class="svg-icon svg-icon-2x me-4" aria-hidden="true"></span>
  }
  <div style="width: 100%;">
    <div class="d-flex justify-content-between mx-2">
      <span class="fs-4 text-gray-600 d-block fw-bold mt-3">{{assetTypeLabel}}</span>
      <div class="align-self-center text-nowrap">
        @if (!isReadOnly) {
          <div class="d-flex">
            <a href="javascript:void(0);" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
              (click)="onDeleteClicked($event)">
              <span class="svg-icon svg-icon-3">
                <duotone-trash-svg-icon></duotone-trash-svg-icon>
              </span>
            </a>
          </div>
        }
      </div>
    </div>
    <div class="text-start mt-3 px-2">
      <div>
        <label class="form-label line-item-text" style="min-width: 6.5rem;">{{ t('wizard.assets.borrowerLabel') }}</label>
        <span>{{ asset.assetOwners }}</span>
      </div>
      <div>
        <label class="form-label line-item-text" style="min-width: 6.5rem;">{{ t('wizard.assets.valueLabel') }}</label>
        <span>{{ asset.value | currency }}</span>
      </div>
    </div>
  </div>
</div>
</ng-container>
